import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-office-representative-district',
  // standalone: true,
  // imports: [],
  templateUrl: './office-representative-district.component.html',
  styleUrl: './office-representative-district.component.scss'
})
export class OfficeRepresentativeDistrictComponent {
   offrepwiseData;
    today = new Date();
    country:any;
    state:any;
    district:any;
    taluka:any;
    startDate = '';
    endDate = '';
    isLoading: boolean = false;
    subTypesName = [
      { name: 'वार्षिक', isVisible: false },
      { name: 'त्रैवार्षिक', isVisible: false },
      { name: 'पंचवार्षिक', isVisible: false },
    ];
    totalth = 0;
    finalData = [];
   
    off_rep_name;
     appliedFilters: any = {}; 
  
    constructor(
      public dialogref: MatDialogRef<OfficeRepresentativeDistrictComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
  
    ngOnInit(): void {
      this.isLoading = true;
  
        this.country = this.data.country;
          this.state = this.data.state;
             this. district = this.data. district;
                this.taluka = this.data.taluka;
      this.offrepwiseData = this.data['offrepwisedata'];
      this.off_rep_name = this.data['off_rep_name'];
      this.startDate = this.data['startDate'];
      this.endDate = this.data['endDate'];
      console.log(this.offrepwiseData);

       this.isLoading = true;
    this.offrepwiseData = this.data['offrepwisedata'];
    this.off_rep_name = this.data['off_rep_name'];
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    // console.log(this.offrepwiseData);
    
    this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);
      
  
      let data = this.uniqueData(this.offrepwiseData, (a) => a.subscription_type);
  
      for (let i = 0; i < Object.keys(data).length; i++) {
        let flag = false;
        for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
          if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
            this.subTypesName[j]['isVisible'] = true;
            flag = true;
            break;
          }
        }
        if (!flag) {
         
          this.subTypesName.push({
            name: data[i]['subscription_type'],
            isVisible: true,
          });
          // }
        }
      }
  
      // console.log(this.subTypesName);
      this.totalth = this.subTypesName.length * 4 + 8;
  
      // this.getoffdata();
      this.setData();
    }
  
   
  
  
  
  
  
  
  // setData() {
  //   this.isLoading = true;
  //   const today = new Date();
  //   today.setMonth(today.getMonth() + 1);
  //   const formattedToday = formatDate(today, 'yyyy-MM-dd', 'en-IN');
  
  //   const finalTotal: any = {
  //     country: 'एकूण',
  //     sub: 0,
  //     'एकूण': 0,
  //     'नवीन': 0,
  //     'नूतनीकरण': 0,
  //     'नूतनीकरणबाकी': 0,
  //     total_amt: 0
  //   };
  
  //   this.subTypesName.forEach(sub => {
  //     if (sub.isVisible) {
  //       const key = sub.name.replace(/\s+/g, '_');
  //       finalTotal[`${key}_एकूण`] = 0;
  //       finalTotal[`${key}_नवीन`] = 0;
  //       finalTotal[`${key}_नूतनीकरण`] = 0;
  //       finalTotal[`${key}_नूतनीकरणबाकी`] = 0;
  //     }
  //   });
  
  //   const grouped: any = {};
  
  //   this.offrepwiseData.forEach(row => {
  //     const country = row.country || 'Unknown Country';
  //     const state = row.state || 'Unknown State';
  //     const rep = row.office_rep_name || 'Unknown Rep';
  //     const district = row.district_name || 'Unknown District';
  //     const taluka = row.taluka || 'Unknown Taluka';
  //     const repName = row.rep_name || 'Unknown Rep';
  
  //     grouped[country] ??= {};
  //     grouped[country][state] ??= {};
  //     grouped[country][state][rep] ??= {};
  //     grouped[country][state][rep][district] ??= {};
  //     grouped[country][state][rep][district][taluka] ??= {};
  //     grouped[country][state][rep][district][taluka][repName] ??= [];
  //     grouped[country][state][rep][district][taluka][repName].push(row);
  //   });
  
  //   const finalData: any[] = [];
  
  //   for (const country in grouped) {
  //     const states = [];
  
  //     for (const state in grouped[country]) {
  //       const office_reps = [];
  
  //       for (const rep in grouped[country][state]) {
  //         const officeRepTotal: any = {
  //           sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0, total_amt: 0
  //         };
  //         this.subTypesName.forEach(sub => {
  //           if (sub.isVisible) {
  //             const key = sub.name.replace(/\s+/g, '_');
  //             officeRepTotal[`${key}_एकूण`] = 0;
  //             officeRepTotal[`${key}_नवीन`] = 0;
  //             officeRepTotal[`${key}_नूतनीकरण`] = 0;
  //             officeRepTotal[`${key}_नूतनीकरणबाकी`] = 0;
  //           }
  //         });
  
  //         const districts = [];
  
  //         for (const district in grouped[country][state][rep]) {
  //           const districtTotal: any = {
  //             sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0, total_amt: 0
  //           };
  //           this.subTypesName.forEach(sub => {
  //             if (sub.isVisible) {
  //               const key = sub.name.replace(/\s+/g, '_');
  //               districtTotal[`${key}_एकूण`] = 0;
  //               districtTotal[`${key}_नवीन`] = 0;
  //               districtTotal[`${key}_नूतनीकरण`] = 0;
  //               districtTotal[`${key}_नूतनीकरणबाकी`] = 0;
  //             }
  //           });
  
  //           const talukas = [];
  
  //           for (const taluka in grouped[country][state][rep][district]) {
  //             const repMap = grouped[country][state][rep][district][taluka];
  //             const representatives = [];
  
  //             for (const repName in repMap) {
  //               const repRows = repMap[repName];
  //               const first = repRows[0];
  //               const repObj: any = {
  //                 rep_name: repName,
  //                 rep_taluka: first.rep_taluka || 'Unknown',
  //                 district: first.district_name || 'Unknown',
  //                 taluka: first.taluka || 'Unknown',
  //                 office_rep_name: first.office_rep_name || 'Unknown',
  //                 total_amt: 0,
  //                 sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0
  //               };
  
  //               this.subTypesName.forEach(sub => {
  //                 if (sub.isVisible) {
  //                   const key = sub.name.replace(/\s+/g, '_');
  //                   repObj[`${key}_एकूण`] = 0;
  //                   repObj[`${key}_नवीन`] = 0;
  //                   repObj[`${key}_नूतनीकरण`] = 0;
  //                   repObj[`${key}_नूतनीकरणबाकी`] = 0;
  //                 }
  //               });
  
  //               repRows.forEach(row => {
  //                 const key = row.subscription_type.replace(/\s+/g, '_');
  //                 const amt = parseInt(row.total_amt || '0');
  //                 const isFuture = row.sub_perid_to_date > formattedToday;
  
  //                 if (isFuture) {
  //                   repObj['sub']++;
  //                   repObj['एकूण'] += amt;
  //                   repObj.total_amt += amt;
  //                   repObj[`${key}_एकूण`] += amt;
  
  //                   if (row.rcpt_type === 'New') {
  //                     repObj['नवीन']++;
  //                     repObj[`${key}_नवीन`] += 1;
  //                   } else if (row.rcpt_type === 'Renew') {
  //                     repObj['नूतनीकरण']++;
  //                     repObj[`${key}_नूतनीकरण`] += 1;
  //                   }
  //                 } else {
  //                   repObj['नूतनीकरणबाकी']++;
  //                   repObj[`${key}_नूतनीकरणबाकी`] += 1;
  //                 }
  //               });
  
  //               // Add to all totals
  //               for (const k in repObj) {
  //                 if (!['rep_name', 'rep_taluka', 'district', 'taluka', 'office_rep_name'].includes(k)) {
  //                   districtTotal[k] += repObj[k] || 0;
  //                   officeRepTotal[k] += repObj[k] || 0;
  //                   finalTotal[k] += repObj[k] || 0;
  //                 }
  //               }
  
  //               representatives.push(repObj);
  //             }
  
  //             talukas.push({ taluka_name: taluka, representatives });
  //           }
  
  //           districts.push({ district_name: district, talukas, total: districtTotal });
  //         }
  
  //         office_reps.push({ office_rep_name: rep, districts, total: officeRepTotal });
  //       }
  
  //       states.push({ state, office_reps });
  //     }
  
  //     finalData.push({ country, states });
  //   }
  
  //   finalData.push(finalTotal);
  //   this.finalData = finalData;
  //   this.isLoading = false;
  // }
  
  
  // setData() {
  //   this.isLoading = true;
  //   const today = new Date();
  //   today.setMonth(today.getMonth() + 1);
  //   const formattedToday = formatDate(today, 'yyyy-MM-dd', 'en-IN');
  
  //   const finalTotal: any = {
  //     country: 'एकूण', sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0, total_amt: 0
  //   };
  
  //   this.subTypesName.forEach(sub => {
  //     if (sub.isVisible) {
  //       const key = sub.name.replace(/\s+/g, '_');
  //       finalTotal[`${key}_एकूण`] = 0;
  //       finalTotal[`${key}_नवीन`] = 0;
  //       finalTotal[`${key}_नूतनीकरण`] = 0;
  //       finalTotal[`${key}_नूतनीकरणबाकी`] = 0;
  //     }
  //   });
  
  //   const grouped: any = {};
  
  //   // Proper nesting by country > state > office rep > district > taluka > rep_name
  //   this.offrepwiseData.forEach(row => {
  //     const country = row.country || 'Unknown Country';
  //     const state = row.state || 'Unknown State';
  //     const rep = row.office_rep_name || 'Unknown Rep';
  //     const district = row.district_name || 'Unknown District';
  //     const taluka = row.taluka || 'Unknown Taluka';
  //     const repName = row.rep_name || 'Unknown Rep';
  
  //     if (!grouped[country]) grouped[country] = {};
  //     if (!grouped[country][state]) grouped[country][state] = {};
  //     if (!grouped[country][state][rep]) grouped[country][state][rep] = {};
  //     if (!grouped[country][state][rep][district]) grouped[country][state][rep][district] = {};
  //     if (!grouped[country][state][rep][district][taluka]) grouped[country][state][rep][district][taluka] = {};
  //     if (!grouped[country][state][rep][district][taluka][repName]) grouped[country][state][rep][district][taluka][repName] = [];
  
  //     grouped[country][state][rep][district][taluka][repName].push(row);
  //   });
  
  //   const finalData: any[] = [];
  
  //   for (const country in grouped) {
  //     const states = [];
  
  //     for (const state in grouped[country]) {
  //       const office_reps = [];
  
  //       for (const rep in grouped[country][state]) {
  //         const officeRepTotal = this.getEmptyTotal();
  //         const districts = [];
  
  //         for (const district in grouped[country][state][rep]) {
  //           const districtTotal = this.getEmptyTotal();
  //           const talukas = [];
  
  //           for (const taluka in grouped[country][state][rep][district]) {
  //             const representatives = [];
  
  //             for (const repName in grouped[country][state][rep][district][taluka]) {
  //               const repRows = grouped[country][state][rep][district][taluka][repName];
  //               const first = repRows[0];
  //               const repObj: any = {
  //                 rep_name: repName,
  //                 rep_taluka: first.rep_taluka || 'Unknown',
  //                 district: first.district_name || 'Unknown',
  //                 taluka: first.taluka || 'Unknown',
  //                 office_rep_name: first.office_rep_name || 'Unknown',
  //                 total_amt: 0, sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0
  //               };
  
  //               this.subTypesName.forEach(sub => {
  //                 if (sub.isVisible) {
  //                   const key = sub.name.replace(/\s+/g, '_');
  //                   repObj[`${key}_एकूण`] = 0;
  //                   repObj[`${key}_नवीन`] = 0;
  //                   repObj[`${key}_नूतनीकरण`] = 0;
  //                   repObj[`${key}_नूतनीकरणबाकी`] = 0;
  //                 }
  //               });
  
  //               repRows.forEach(row => {
  //                 const key = row.subscription_type.replace(/\s+/g, '_');
  //                 const amt = +row.total_amt || 0;
  //                 const isFuture = row.sub_perid_to_date > formattedToday;
  
  //                 if (isFuture) {
  //                   repObj.sub++;
  //                   repObj['एकूण'] += amt;
  //                   repObj.total_amt += amt;
  //                   repObj[`${key}_एकूण`] += amt;
  
  //                   if (row.rcpt_type === 'New') {
  //                     repObj['नवीन']++;
  //                     repObj[`${key}_नवीन`] += 1;
  //                   } else if (row.rcpt_type === 'Renew') {
  //                     repObj['नूतनीकरण']++;
  //                     repObj[`${key}_नूतनीकरण`] += 1;
  //                   }
  //                 } else {
  //                   repObj['नूतनीकरणबाकी']++;
  //                   repObj[`${key}_नूतनीकरणबाकी`] += 1;
  //                 }
  //               });
  
  //               // Add to all totals
  //               for (const k in repObj) {
  //                 if (!['rep_name', 'rep_taluka', 'district', 'taluka', 'office_rep_name'].includes(k)) {
  //                   districtTotal[k] += repObj[k] || 0;
  //                   officeRepTotal[k] += repObj[k] || 0;
  //                   finalTotal[k] += repObj[k] || 0;
  //                 }
  //               }
  
  //               representatives.push(repObj);
  //             }
  
  //             talukas.push({ taluka_name: taluka, representatives });
  //           }
  
  //           districts.push({ district_name: district, talukas, total: districtTotal });
  //         }
  
  //         office_reps.push({ office_rep_name: rep, districts, total: officeRepTotal });
  //       }
  
  //       states.push({ state, office_reps });
  //     }
  
  //     finalData.push({ country, states });
  //   }
  
  //   finalData.push(finalTotal);
  //   this.finalData = finalData;
  //   this.isLoading = false;
  // }
  
  
  // setData() {
  //   this.isLoading = true;
  //   const today = new Date();
  //   today.setMonth(today.getMonth() + 1);
  //   const formattedToday = formatDate(today, 'yyyy-MM-dd', 'en-IN');
  
  //   const finalTotal: any = {
  //     country: 'एकूण', sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0, total_amt: 0
  //   };
  
  //   const getEmptyTotal = () => {
  //     const total: any = { sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0, total_amt: 0 };
  //     this.subTypesName.forEach(sub => {
  //       if (sub.isVisible) {
  //         const key = sub.name.replace(/\s+/g, '_');
  //         total[`${key}_एकूण`] = 0;
  //         total[`${key}_नवीन`] = 0;
  //         total[`${key}_नूतनीकरण`] = 0;
  //         total[`${key}_नूतनीकरणबाकी`] = 0;
  //       }
  //     });
  //     return total;
  //   };
  
  //   const grouped: any = {};
  
  //   this.offrepwiseData.forEach(row => {
  //     const country = row.country || 'Unknown Country';
  //     const state = row.state || 'Unknown State';
  //     const rep = row.office_rep_name || 'Unknown Rep';
  //     const district = row.district_name || 'Unknown District';
  //     const taluka = row.taluka || 'Unknown Taluka';
  //     const repName = row.rep_name || 'Unknown Rep';
  
  //     if (!grouped[country]) grouped[country] = {};
  //     if (!grouped[country][state]) grouped[country][state] = {};
  //     if (!grouped[country][state][rep]) grouped[country][state][rep] = {};
  //     if (!grouped[country][state][rep][district]) grouped[country][state][rep][district] = {};
  //     if (!grouped[country][state][rep][district][taluka]) grouped[country][state][rep][district][taluka] = {};
  //     if (!grouped[country][state][rep][district][taluka][repName]) grouped[country][state][rep][district][taluka][repName] = [];
  
  //     grouped[country][state][rep][district][taluka][repName].push(row);
  //   });
  
  //   const finalData: any[] = [];
  
  //   for (const country in grouped) {
  //     const states = [];
  
  //     for (const state in grouped[country]) {
  //       const office_reps = [];
  
  //       for (const rep in grouped[country][state]) {
  //         const officeRepTotal = getEmptyTotal();
  //         const districts = [];
  
  //         for (const district in grouped[country][state][rep]) {
  //           const districtTotal = getEmptyTotal();
  //           const talukas = [];
  
  //           for (const taluka in grouped[country][state][rep][district]) {
  //             const representatives = [];
  
  //             for (const repName in grouped[country][state][rep][district][taluka]) {
  //               const repRows = grouped[country][state][rep][district][taluka][repName];
  //               const first = repRows[0];
  
  //               const repObj: any = {
  //                 rep_name: repName,
  //                 rep_taluka: first.rep_taluka || 'Unknown',
  //                 district: first.district_name || 'Unknown',
  //                 taluka: first.taluka || 'Unknown',
  //                 office_rep_name: first.office_rep_name || 'Unknown',
  //                 total_amt: 0, sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0
  //               };
  
  //               this.subTypesName.forEach(sub => {
  //                 if (sub.isVisible) {
  //                   const key = sub.name.replace(/\s+/g, '_');
  //                   repObj[`${key}_एकूण`] = 0;
  //                   repObj[`${key}_नवीन`] = 0;
  //                   repObj[`${key}_नूतनीकरण`] = 0;
  //                   repObj[`${key}_नूतनीकरणबाकी`] = 0;
  //                 }
  //               });
  
  //               repRows.forEach(row => {
  //                 const key = row.subscription_type.replace(/\s+/g, '_');
  //                 const amt = +row.total_amt || 0;
  //                 const isFuture = row.sub_perid_to_date > formattedToday;
  
  //                 if (isFuture) {
  //                   repObj.sub++;
  //                   repObj['एकूण'] += amt;
  //                   repObj.total_amt += amt;
  //                   repObj[`${key}_एकूण`] += amt;
  
  //                   if (row.rcpt_type === 'New') {
  //                     repObj['नवीन']++;
  //                     repObj[`${key}_नवीन`] += 1;
  //                   } else if (row.rcpt_type === 'Renew') {
  //                     repObj['नूतनीकरण']++;
  //                     repObj[`${key}_नूतनीकरण`] += 1;
  //                   }
  //                 } else {
  //                   repObj['नूतनीकरणबाकी']++;
  //                   repObj[`${key}_नूतनीकरणबाकी`] += 1;
  //                 }
  //               });
  
  //               for (const k in repObj) {
  //                 if (!['rep_name', 'rep_taluka', 'district', 'taluka', 'office_rep_name'].includes(k)) {
  //                   districtTotal[k] += repObj[k] || 0;
  //                   officeRepTotal[k] += repObj[k] || 0;
  //                   finalTotal[k] += repObj[k] || 0;
  //                 }
  //               }
  
  //               representatives.push(repObj);
  //             }
  
  //             talukas.push({ taluka_name: taluka, representatives });
  //           }
  
  //           // Add main district object
  //           districts.push({
  //             district_name: district,
  //             talukas,
  //             isTotalRow: false
  //           });
  
  //           // Add separate district total row object
  //           districts.push({
  //             isTotalRow: true,
  //             district_name: district,
  //             total: { ...districtTotal }
  //           });
  //         }
  
  //         office_reps.push({ office_rep_name: rep, districts, total: officeRepTotal });
  //       }
  
  //       states.push({ state, office_reps });
  //     }
  
  //     finalData.push({ country, states });
  //   }
  
  //   finalData.push(finalTotal);
  //   this.finalData = finalData;
  //   this.isLoading = false;
  // }
  
  setData() {
    this.isLoading = true;
    const today = new Date();
    today.setMonth(today.getMonth() + 1);
    const formattedToday = formatDate(today, 'yyyy-MM-dd', 'en-IN');
  
    const getEmptyTotal = () => {
      const total: any = {
        sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0, total_amt: 0
      };
      this.subTypesName.forEach(sub => {
        const key = sub.name.replace(/\s+/g, '_');
        total[`${key}_एकूण`] = 0;
        total[`${key}_नवीन`] = 0;
        total[`${key}_नूतनीकरण`] = 0;
        total[`${key}_नूतनीकरणबाकी`] = 0;
      });
      return total;
    };
  
    const finalTotal: any = getEmptyTotal();
    finalTotal.country = 'एकूण';
  
    const grouped: any = {};
  
    this.offrepwiseData.forEach(row => {
      const country = row.country || 'Unknown Country';
      const state = row.state || 'Unknown State';
      const rep = row.office_rep_name || 'Unknown Rep';
      const district = row.district_name || 'Unknown District';
      const taluka = row.taluka || 'Unknown Taluka';
      const repName = row.rep_name || 'Unknown Rep';
  
      if (!grouped[country]) grouped[country] = {};
      if (!grouped[country][state]) grouped[country][state] = {};
      if (!grouped[country][state][rep]) grouped[country][state][rep] = {};
      if (!grouped[country][state][rep][district]) grouped[country][state][rep][district] = {};
      if (!grouped[country][state][rep][district][taluka]) grouped[country][state][rep][district][taluka] = {};
      if (!grouped[country][state][rep][district][taluka][repName]) grouped[country][state][rep][district][taluka][repName] = [];
  
      grouped[country][state][rep][district][taluka][repName].push(row);
    });
  
    const finalData: any[] = [];
  
    for (const country in grouped) {
      const states = [];
  
      for (const state in grouped[country]) {
        const office_reps = [];
  
        for (const rep in grouped[country][state]) {
          const officeRepTotal = getEmptyTotal();
          const districts = [];
  
          for (const district in grouped[country][state][rep]) {
            const districtTotal = getEmptyTotal();
            const talukas = [];
  
            for (const taluka in grouped[country][state][rep][district]) {
              const representatives = [];
  
              for (const repName in grouped[country][state][rep][district][taluka]) {
                const repRows = grouped[country][state][rep][district][taluka][repName];
                const first = repRows[0];
  
                const repObj: any = {
                  rep_name: repName,
                  rep_taluka: first.rep_taluka || 'Unknown',
                  district: first.district_name || 'Unknown',
                  taluka: first.taluka || 'Unknown',
                  office_rep_name: first.office_rep_name || 'Unknown',
                  total_amt: 0,
                  sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0
                };
  
                this.subTypesName.forEach(sub => {
                  const key = sub.name.replace(/\s+/g, '_');
                  repObj[`${key}_एकूण`] = 0;
                  repObj[`${key}_नवीन`] = 0;
                  repObj[`${key}_नूतनीकरण`] = 0;
                  repObj[`${key}_नूतनीकरणबाकी`] = 0;
                });
  
                repRows.forEach(row => {
                  const key = row.subscription_type?.replace(/\s+/g, '_') || 'Unknown';
                  const amt = +row.total_amt || 0;
                  const isFuture = row.sub_perid_to_date > formattedToday;
  
                  if (isFuture) {
                    repObj.sub++;
                    repObj['एकूण'] += amt;
                    repObj.total_amt += amt;
                    repObj[`${key}_एकूण`] += amt;
  
                    if (row.rcpt_type === 'New') {
                      repObj['नवीन']++;
                      repObj[`${key}_नवीन`] += 1;
                    } else if (row.rcpt_type === 'Renew') {
                      repObj['नूतनीकरण']++;
                      repObj[`${key}_नूतनीकरण`] += 1;
                    }
                  } else {
                    repObj['नूतनीकरणबाकी']++;
                    repObj[`${key}_नूतनीकरणबाकी`] += 1;
                  }
                });
  
                // Add to higher levels
                for (const k in repObj) {
                  if (!['rep_name', 'rep_taluka', 'district', 'taluka', 'office_rep_name'].includes(k)) {
                    districtTotal[k] = (districtTotal[k] || 0) + (repObj[k] || 0);
                    officeRepTotal[k] = (officeRepTotal[k] || 0) + (repObj[k] || 0);
                    finalTotal[k] = (finalTotal[k] || 0) + (repObj[k] || 0);
                  }
                }
  
                representatives.push(repObj);
              }
  
              talukas.push({ taluka_name: taluka, representatives });
            }
  
            // Main district block
            districts.push({
              district_name: district,
              talukas,
              isTotalRow: false
            });
  
            // Total row block
            districts.push({
              isTotalRow: true,
              district_name: district,
              total: { ...districtTotal }
            });
          }
  
          office_reps.push({
            office_rep_name: rep,
            districts,
            total: officeRepTotal
          });
        }
  
        states.push({ state, office_reps });
      }
  
      finalData.push({ country, states });
    }
  
    finalData.push(finalTotal);
    this.finalData = finalData;
    this.isLoading = false;
  }
  
  
  
  
  getEmptyTotal() {
    const total: any = {
      sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0, total_amt: 0
    };
    this.subTypesName.forEach(sub => {
      if (sub.isVisible) {
        const key = sub.name.replace(/\s+/g, '_');
        total[`${key}_एकूण`] = 0;
        total[`${key}_नवीन`] = 0;
        total[`${key}_नूतनीकरण`] = 0;
        total[`${key}_नूतनीकरणबाकी`] = 0;
      }
    });
    return total;
  }
  
  
  
    getKey(name) {
      return name.replaceAll(' ', '_');
    }
  
    uniqueData(data, key) {
      return [...new Map(data.map((a) => [key(a), a])).values()];
    }
  
    exportExcel(fileName) {
      /* table id is passed over here */
      let element = document.getElementById('print-section');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, fileName + '.xlsx');
    }
  
  
    show=false 
    printPage() {
      this.show=true
      const printContent = document.getElementById('print-section')?.outerHTML;
      if (!printContent) {
          console.error("Print section not found!");
          return;
      }
  
      const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
  
      if (printWindow) {
          printWindow.document.open();
          printWindow.document.write(`
              <html>
                  <head>
                      <title>Print Report</title>
                      <style>
                          @media print {
                              @page { 
                                  size: A3 landscape; /* Set A3 size with landscape mode */
                                  margin: 5mm; /* Adjust margins */
                              }
                              body { 
                                  font-family: Arial, sans-serif; 
                                  font-size: 15px; /* Adjust font size */
                                  margin: 0; 
                                  padding: 5mm; 
                                  line-height: 1.2; 
                              }
                              table { 
                                  width: 100%; 
                                  height: 100%;
                                  border-collapse: collapse; 
                                  table-layout: fixed; /* Prevent column expansion */
                                  page-break-inside: avoid; /* Avoid breaking the table */
                              }
                              th, td { 
                                  padding: 1px; 
                                  border: 1px solid black; 
                                  text-align: center; 
                                  font-size: 14px; /* Adjusted font size */
                                  line-height: 1.2; 
                              }
                              .noPrint { 
                                  display: none; /* Hide print button */
                              }
                          }
                      </style>
                  </head>
                  <body>
                      <div id="print-section">
                          ${printContent}
                      </div>
                      <script>
                          window.onload = function() { 
                              window.print(); 
                              setTimeout(() => { window.close(); }, 500);
                          };
                      </script>
                  </body>
              </html>
          `);
          printWindow.document.close();
      } else {
          console.error("Failed to open print window.");
      }
  }
  
  }
  // }
  


